<template>
    <el-pagination background layout="total, prev, pager, next" :total="pageInfo.rowCount" :page-size="pageInfo.pageSize" @current-change="hanlerPageChange" :current-page.sync="pageInfo.pageNo" :page-count="pageInfo.totalPage" ></el-pagination>
</template>
<script>
    export default {
        props: {
            //页码信息
            pageInfo: {
                required: true,
                type: Object
            },

            // 分页回调函数
            callback: {
                type: Function
            },
        },
        methods: {
            hanlerPageChange(page) {
                this.callback(page);
            }
        }
    }
</script>